<fieldset>
    <div class="fixed-section">
        <section class="titleBarBg fixed-top">
            <div class="container-fluid">
                <div class="row mar-7px">
                    <div class="w-3">
                        <img src="assets/images/manage_sales_plan_icon.svg" class="pageIcon" alt="">
                    </div>
                    <div class="w-97">
                        <div class="pageHeadingBar">
                            <div class="row">
                                <div class="col-md-6 align-self-center">
                                    <h6 class="pageHeadingText mb-0 text-uppercase">MASTER DATA MANAGEMENT</h6>
                                </div>

                                <div class="col-md-3 align-self-center">

                                </div>
                                <div class="col-md-3 align-self-center text-end">
                                    <ul class="list-inline mb-0" *ngIf="activeTab=='storestab'">
                                        <li class="list-inline-item">
                                            <img *ngIf="disableExportStoresListAction"
                                                src="assets/images/loader_btn.gif" class="buttonsmallIcon mr-2"
                                                alt="Loader">

                                            <img src="assets/images/export.png" class="me-1 w-25px pointerCursor"
                                                alt="Export" title="Export"
                                                [class.disabled]="disableExportStoresListAction"
                                                (click)="!disableExportStoresListAction && exportStoresList()">

                                        </li>

                                    </ul>
                                    <!-- <ul class="list-inline mb-0">
                                    <li class="list-inline-item">
                                        <a href="#">
                                           <img src="images/export.png" class="me-1 w-25px" alt="" title="Export">
                                        </a>
                                    </li>
                                    <li class="list-inline-item">
                                        <div class="nav-item dropdown">
                                            <a class="nav-link dropdown-toggle urserName" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                <img src="images/filter.png" class="w-20px me-2" alt="" title="Filter">

                                            </a>
                                            <ul class="dropdown-menu customMargindrp w-300">


                                                <div class="row mb-12px">
                                                    <div class="col-md-5">
                                                        <label>TYPE</label>
                                                    </div>
                                                    <div class="col-md-7 ps-0">
                                                        <select class="form-select" aria-label="Default select example">
                                                            <option selected=""></option>
                                                            <option value="1">One</option>
                                                            <option value="2">Two</option>
                                                            <option value="3">Three</option>
                                                        </select>
                                                    </div>
                                                </div>

                                                <div class="row mb-12px">
                                                    <div class="col-md-5">
                                                        <label>CATEGORY</label>
                                                    </div>
                                                    <div class="col-md-7 ps-0">
                                                        <select class="form-select" aria-label="Default select example">
                                                            <option selected=""></option>
                                                            <option value="1">One</option>
                                                            <option value="2">Two</option>
                                                            <option value="3">Three</option>
                                                        </select>
                                                    </div>
                                                </div>

                                                <div class="row mb-12px">
                                                    <div class="col-md-5">
                                                        <label>AGENCY</label>
                                                    </div>
                                                    <div class="col-md-7 ps-0">
                                                        <select class="form-select" aria-label="Default select example">
                                                            <option selected=""></option>
                                                            <option value="1">One</option>
                                                            <option value="2">Two</option>
                                                            <option value="3">Three</option>
                                                        </select>
                                                    </div>
                                                </div>

                                                <div class="row mb-12px">
                                                    <div class="col-md-5">
                                                        <label>STATUS</label>
                                                    </div>
                                                    <div class="col-md-7 ps-0">
                                                        <select class="form-select" aria-label="Default select example">
                                                            <option selected=""></option>
                                                            <option value="1">One</option>
                                                            <option value="2">Two</option>
                                                            <option value="3">Three</option>
                                                        </select>
                                                    </div>
                                                </div>

                                               


                                                <div class="row ">
                                                    <div class="offset-md-5 col-md-7 ps-0">
                                                        
                                                            <button class="btn progressBtn w-100" role="button">
                                                                APPLY FILTER
                                                            </button>
                                                    </div>
                                                </div>


                                            </ul>
                                        </div>
                                    </li>
                                </ul> -->
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>

    <div class="middleContent mt-131">
        <section class="mt-131">
            <div class="container-fluid px-2">
                <div class="row">
                    <div class="col-md-12">
                        <div class="card border-0 stepsBars-2">

                            <div class="card-body">
                                <div class="row d-flex">
                                    <div class="leftMenuSec pad-right-30  border-right-solid">
                                        <label class="fw-bold text-dark mb-3">SELECT CATEGORY</label>
                                        <div class="nav flex-column nav-pills me-3" id="v-pills-tab" role="tablist"
                                            aria-orientation="vertical">
                                            <button class="nav-link active ps-2 text-start" id="v-pills-home-tab"
                                                data-bs-toggle="pill" data-bs-target="#v-pills-home" type="button"
                                                (click)="setActiveTab('productstab')" role="tab"
                                                aria-controls="v-pills-home" aria-selected="false">
                                                <span>PRODUCTS</span>
                                            </button>
                                            <button class="nav-link ps-2 text-start" id="v-pills-profile-tab"
                                                data-bs-toggle="pill" data-bs-target="#v-pills-profile" type="button"
                                                (click)="setActiveTab('storestab')" role="tab"
                                                aria-controls="v-pills-profile" aria-selected="true" tabindex="-1">
                                                <span> STORES</span>
                                            </button>

                                            <button class="nav-link ps-2 text-start" id="brand-subbrand-tab"
                                                data-bs-toggle="pill" data-bs-target="#brand-subbrand" type="button"
                                                (click)="setActiveTab('materialstab')" role="tab"
                                                aria-controls="brand-subbrand" aria-selected="false" tabindex="-1">
                                                <span> MATERIALS</span>
                                            </button>

                                            <button class="nav-link ps-2 text-start" id="brand-datasetup-tab"
                                                data-bs-toggle="pill" data-bs-target="#brand-datasetup" type="button"
                                                (click)="setActiveTab('masterdatasetuptab')" role="tab"
                                                aria-controls="brand-datasetup" aria-selected="false" tabindex="-1">
                                                <span> MASTER DATA SETUP</span>
                                            </button>


                                        </div>
                                    </div>
                                    <div class="messagesSec pad-80">

                                        <div class="tab-content" id="v-pills-tabContent">

                                            <!--------------------Products tab started from here------------------->

                                            <div class="tab-pane fade show active" id="v-pills-home" role="tabpanel"
                                                aria-labelledby="v-pills-home-tab" tabindex="0">
                                                <app-master-products
                                                    *ngIf="activeTab=='productstab'"></app-master-products>
                                            </div>
                                            <!--------------------End Products tab here------------------->


                                            <!--------------------Stores tab started from here---------------------->
                                            <div class="tab-pane fade" id="v-pills-profile" role="tabpanel"
                                                aria-labelledby="v-pills-profile-tab" tabindex="0">
                                                <app-master-stores *ngIf="activeTab=='storestab'" #masterStores
                                                    (exportComplete)="onExportStoresListComplete()"></app-master-stores>
                                            </div>
                                            <!--------------------End Stores tab here---------------------->


                                            <!--------------------Meterials tab started from here---------------------->
                                            <div class="tab-pane fade" id="brand-subbrand" role="tabpanel"
                                                aria-labelledby="brand-subbrand-tab" tabindex="0">
                                                <app-master-material
                                                    *ngIf="activeTab=='materialstab'"></app-master-material>
                                            </div>
                                            <!--------------------End Meterials tab here---------------------->

                                            <!--------------------Master Data Setup tab started from here---------------------->
                                            <div class="tab-pane fade" id="brand-datasetup" role="tabpanel"
                                                aria-labelledby="brand-datasetup-tab" tabindex="0">
                                                <app-master-data-setup
                                                    *ngIf="activeTab=='masterdatasetuptab'"></app-master-data-setup>
                                            </div>
                                            <!--------------------End Master Data Setup tab here---------------------->


                                        </div>




                                    </div>
                                </div>
                            </div>



                        </div>


                    </div>
                </div>
            </div>
        </section>



    </div>
</fieldset>


<!-- <app-master-products></app-master-products> -->